import viewMixin from '../../../components/core/consumers/viewMixin';
import ApiService from '../../../services/apiService';
import { userItemsPerListMixin } from '../../../utils/vuex';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import { mapState } from 'vuex';
const emptyModel = {
  chain: [],
  trigger: {}
};
const defaultItemsPerPage = 10;
const defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'ViewConnectorsConsumersChains',
  mixins: [viewMixin, userItemsPerListMixin],
  data() {
    return {
      searchItem: '',
      deleteItemId: null,
      deletePrompt: false,
      accounts: [],
      selectedAccounts: [],
      selectedAccount: null,
      createForAccount: null,
      consumers: [],
      bridgeTypes: [],
      consumerModel: cloneDeep(emptyModel),
      newChainItemType: null,
      isCreateDialog: true,
      tableOptions: defaultTableOptions,
      dialogFormValid: false
    };
  },
  computed: {
    ...mapState('authentication', ['tenantId']),
    hasNoChains() {
      return this.consumers.length === 0;
    },
    triggerSources() {
      return [{
        value: 'stateIngest',
        text: 'BEFORE STATE-HANDLING'
      }, {
        value: 'influxdbDataPoint',
        text: 'AFTER STATE-HANDLING'
      }, {
        value: 'alarmLogEntry',
        text: 'ALARM-LOG WAS CREATED/RESOLVED'
      }];
    },
    tableLocalizations() {
      return {
        headers: [{
          text: this.$i18n_t('NiotaClassic.Common.table.id'),
          value: 'id',
          align: 'center'
        }, {
          text: this.$i18n_t('NiotaClassic.Consumers.table.name'),
          value: 'name',
          align: 'start'
        }, {
          text: this.$i18n_t('Bridges.Consumers.chains.trigger'),
          value: 'triggerType',
          align: 'start'
        }, {
          text: this.$i18n_t('Bridges.Consumers.chains.steps'),
          sortable: true,
          value: 'steps',
          align: 'start'
        }, {
          text: this.$i18n_t('accMgmt.tenant.bridges.title'),
          sortable: false,
          value: 'bridges',
          align: 'start'
        }, {
          text: this.$i18n_t('NiotaClassic.Common.table.account'),
          value: 'tenantId'
        }, {
          text: this.$i18n_t('NiotaClassic.Common.table.createdAt'),
          value: 'createdAt'
        }, {
          value: 'actions'
        }],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [10, 20, 50]
        }
      };
    }
  },
  watch: {
    selectedAccounts() {
      this.fetchTenantData();
    }
  },
  created() {
    this.fetchAccounts();
  },
  methods: {
    async fetchTenantData() {
      this.isLoading = true;
      if (!this.selectedAccounts) {
        this.selectedAccounts = [];
      }
      const ids = this.selectedAccounts.map(acc => acc.id);
      Promise.all([await ApiService.consumersFetch(ids), this.bridgeTypes.length ? Promise.resolve(this.bridgeTypes) : await ApiService.getBridgeTypes()]).then(data => {
        this.bridgeTypes = data[1];
        this.consumers = data[0].map(c => {
          c.bridges = c.bridges.map(b => {
            const bridgeType = this.bridgeTypes.find(t => t.type === b.type);
            b.displayName = bridgeType ? get(bridgeType, 'manifest.displayName') : '';
            return b;
          });
          return {
            ...c,
            steps: c.chain.length
          };
        });
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        this.isLoading = false;
      });
    },
    openEditModal(item = null) {
      this.consumerModel = cloneDeep(item || emptyModel);
      this.formDialogOpen = true;
      if (item === null) {
        this.selectedAccount = null;
        this.isCreateDialog = true;
      } else {
        this.isCreateDialog = false;
        this.selectedAccount = this.accounts.find(acc => acc.id === item.tenantId);
      }
    },
    save() {
      const accountId = get(this, '$refs.chainsEdit.account.id');
      let promise = null;
      if (this.consumerModel.id) {
        promise = ApiService.consumersUpdate(this.consumerModel.id, this.consumerModel);
      } else {
        promise = ApiService.consumersCreate(accountId, this.consumerModel);
      }
      promise.then(() => {
        if (this.consumerModel.id) {
          this.$snack(`${this.$i18n_t('Bridges.Consumers.chains.integrationflowUpdated')}`, 'success');
        } else {
          this.$snack(`${this.$i18n_t('Bridges.Consumers.chains.integrationflowCreated')}`, 'success');
        }
        this.fetchTenantData();
        this.closeDialog();
      }).catch(e => {
        let error = get(e, 'response.data.message', '');
        if (error === 'CONSUMER_CHAIN_INCOMPATIBLE') {
          error = this.$i18n_t('Bridges.Consumers.chains.errors.incompatibleSteps');
        }
        this.$snack(error, 'error');
      });
    },
    showDeletePrompt(id) {
      this.deleteItemId = id;
      this.deletePrompt = true;
    },
    deleteConsumer(id) {
      ApiService.consumersDelete(id).then(() => {
        this.fetchTenantData();
      }).catch(e => {
        this.$snack(e.response.data.message, 'error');
      }).finally(() => {
        this.deletePrompt = false;
      });
    },
    fetchAccounts() {
      this.isLoading = true;
      this.$store.dispatch('app/loadAccounts').then(accounts => {
        this.accounts = accounts;
        this.fetchTenantData();
      }).catch(error => {
        console.error(error);
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');
        this.isLoading = false;
      });
    }
  }
};